import { extend, configure } from 'vee-validate';
import {
  // eslint-disable-next-line camelcase
  required, min, numeric, min_value, max_value, regex, digits,
} from 'vee-validate/dist/rules';
import i18n from './i18n';

configure({
  defaultMessage: (field, values) => {
    // eslint-disable-next-line no-underscore-dangle, no-param-reassign
    values._field_ = i18n.t(`fields.${field}`);

    // eslint-disable-next-line no-underscore-dangle
    return i18n.t(`validation.${values._rule_}`, values);
  },
});

extend('required', required);
extend('min', min);
extend('min_value', min_value);
extend('max_value', max_value);
extend('numeric', numeric);
extend('digits', digits);
extend('regex', regex);
